import RolesService from "../services/roles.sevice";

const state = {
	roles: [],
	rolePermissions: [],
	addedRolePermArray: null,
	notAllowedError: false,
	deleteRoleErrorMessage: '',
	response: ''
};

const getters = {
	rolesList: (state) => {
		let rolesList = state.roles;
		for (let role of rolesList) {
			role.permissions = ''
		}
		return rolesList
	},

	permList: (state) => {
		return state.rolePermissions
	},
	response: (state) => {
		if (state.response == 'success') {
			return state.response = 'Permission qoshildi';
		}
	},
	role: (state) => {
		return (roleId) => {
			return state.roles.find(role => {
				return role.id == roleId;
			})
		};
	}
}


const actions = {
	async getRolesList({commit}) {
		try {
			const roles = await RolesService.getRoles();
			commit('setRoles', roles.data);
			return true
		} catch (e) {
			return false
		}
	},
	async deleteRoleWithId({commit}, id) {
		try {
			const deleteResponse = await RolesService.deleteRole(id);
			commit('setDeletedRole', {deleteResponse, id});
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('deleteRoleError', {message: response.message, boolean: true});
			return false;
		}

	},
	async editRole({commit}, newRole) {
		try {
			const editResponse = await RolesService.editRole(newRole);
			return true;
		} catch (e) {
			return false
		}
	},
	async createNewRole({commit}, newRole) {
		try {
			const {data} = await RolesService.createRole(newRole);
			return true;
		} catch (e) {
			return false
		}
	},
	async FetchPermList({commit}, roleId) {
		try {
			const getResponsePerm = await RolesService.permListData(roleId);
			commit('setRolePermissions', getResponsePerm.data);
			return true;
		} catch (e) {
			return false;
		}

	},
	async saveRolePermissions({commit}, payloadArray) {
		try {
			const getResponseRolePermArray = await RolesService.saveRolePermissionsApi(payloadArray)
			commit('saveRolePermArray', getResponseRolePermArray.data);
			return true;
		} catch (e) {
			return false;
		}
	},
};

const mutations = {
	setRoles(state, roles) {
		state.roles = roles;
	},
	setRolePermissions(state, rolePermissions) {
		state.rolePermissions = rolePermissions;
	},
	setDeletedRole(state, payload) {
		if (payload.deleteResponse) {
			let foundIndex = state.roles.findIndex(x => x.id == payload.id);
			state.roles.splice(foundIndex, 1);
			state.notAllowedError = false;
		}
	},
	deleteRoleError(state, payload) {
		state.notAllowedError = payload.boolean;
		state.deleteRoleErrorMessage = payload.message;
	},
	saveRolePermArray(state, addedRolePermArray) {
		state.response = addedRolePermArray
	},

};

export const roles = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
